import { CommonModule, DatePipe, NgForOf, NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  TuiAppearance,
  TuiDataList,
  TuiDropdown,
  TuiLink,
  TuiTextfield,
} from "@taiga-ui/core";
import {
  TuiBreadcrumbs,
  TuiDataListWrapper,
  TuiFade,
  TuiItemsWithMore,
  TuiTabs,
} from "@taiga-ui/kit";
import { TuiCell, TuiNavigation, TuiSearch } from "@taiga-ui/layout";
import { TuiTable } from "@taiga-ui/addon-table";
import {
  TuiComboBoxModule,
  TuiInputSliderModule,
  TuiTextfieldControllerModule,
} from "@taiga-ui/legacy";
import { InvoiceService } from "../../../core/services/invoice.service";
import { formatClientIdentifier } from "../../../shared/utils/client-identifier";

@Component({
  selector: "app-single-invoice",
  imports: [
    FormsModule,
    NgForOf,
    NgIf,
    TuiAppearance,
    TuiDataListWrapper,
    TuiBreadcrumbs,
    TuiDataList,
    TuiDropdown,
    TuiFade,
    TuiTable,
    TuiLink,
    TuiNavigation,
    TuiTabs,
    TuiTextfield,
    TuiCell,
    TuiItemsWithMore,
    TuiSearch,
    ReactiveFormsModule,
    CommonModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiComboBoxModule,
  ],
  templateUrl: "./single-invoice.component.html",
  styleUrl: "./single-invoice.component.scss",
})
export class SingleInvoiceComponent implements OnInit {
  protected breadcrumbs: string[] = ["Royal Hospital", "Invoices", "IN00001"];
  isLoading = false;
  invoiceId: string = "";
  invoice: any | null = null;
  private monthParam!: number;
  private yearParam!: number;
  public billingDate!: Date;

  constructor(
    private router: Router,
    private InvoiceService: InvoiceService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) {}

  navigateTo(index: number): void {
    switch (index) {
      case 0:
        this.router.navigate(["admin/invoice"]);
        break;
      case 1:
        this.router.navigate(["admin/invoice"]);
        break;
    }
  }

  ngOnInit(): void {
    this.invoiceId = this.route.snapshot.paramMap.get('id')!;

    const m = this.route.snapshot.paramMap.get('month');
    const y = this.route.snapshot.paramMap.get('year');
    if (m && y) {
      this.monthParam = parseInt(m, 10);
      this.yearParam = parseInt(y, 10);
      this.billingDate = new Date(this.yearParam, this.monthParam, 0);
    }

    if (this.invoiceId) {
      this.loadNurseData();
    }
  }

  loadNurseData(): void {
    this.isLoading = true;
    if (this.invoiceId) {
      this.InvoiceService.getOneInvoiceById(this.invoiceId).subscribe(
        (res: any) => {
          console.log("My redavshdnvkujhosd",res);
          this.invoice = res;
          this.breadcrumbs = ["Royal Hospital", "Invoices", this.invoiceNumberDisplay];
          this.isLoading = false;
        }
      );
    }
  }

  get invoiceClientRefDisplay(): string {
    return formatClientIdentifier(this.invoice?.clientId);
  }

  get invoiceNumberDisplay(): string {
    const refNo = String(this.invoice?.refNo ?? "").trim();
    return refNo || "—";
  }
}
